import cx from 'classnames';
import { makeResponsive } from '../../utils';
import styles from './index.module.scss';
/**
 * @typedef {"center" | "flex-end" | "flex-start" | "space-around" | "space-between" | "space-evenly" | "stretch"} alignContent
 *
 * @param alignContent {alignContent}
 * @returns - [className, style]
 *
 * @example
 * const [classnames, style] = getAlignContent('center');
 */

export var getAlignContent = function getAlignContent(alignContent) {
  var classnames = cx(makeResponsive(styles, alignContent, 'alignContent'));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classnames, undefined];
};
/**
 * @typedef {"flex-start" | "center" | "flex-end" | "stretch" | "baseline"} alignItems
 *
 * @param alignItems {alignItems}
 * @returns - [className, style]
 *
 * @example
 * const [classnames, style] = getAlignItems('center');
 */

export var getAlignItems = function getAlignItems(alignItems) {
  var classnames = cx(makeResponsive(styles, alignItems, 'alignItems'));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classnames, undefined];
};
/**
 * @typedef {"row" | "row-reverse" | "column" | "column-reverse"} flexDirection
 *
 * @param flexDirection {flexDirection}
 * @returns - [className, style]
 *
 * @example
 * const [classnames, style] = getFlexDirection('center');
 */

export var getFlexDirection = function getFlexDirection(flexDirection) {
  var classnames = cx(makeResponsive(styles, flexDirection, 'flexDirection'));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classnames, undefined];
};
/**
 * @typedef {"nowrap" | "wrap" | "wrap-reverse"} flexWrap
 *
 * @param flexWrap {flexWrap}
 * @returns - [className, style]
 *
 * @example
 * const [classnames, style] = getFlexWrap('center');
 */

export var getFlexWrap = function getFlexWrap(flexWrap) {
  var classnames = cx(makeResponsive(styles, flexWrap, 'flexWrap'));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classnames, undefined];
};
/**
 * @typedef {"flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly"} justifyContent
 *
 * @param justifyContent {justifyContent}
 * @returns - [className, style]
 *
 * @example
 * const [classnames, style] = getJustifyContent('center');
 */

export var getJustifyContent = function getJustifyContent(justifyContent) {
  var classnames = cx(makeResponsive(styles, justifyContent, 'justifyContent'));
  /**
   * We return an array and not an object, for renaming reasons.
   */

  return [classnames, undefined];
};